import React from 'react';
import { Card, CardContent, Grid } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { GameInfo } from '@domain/game.selection/types/game.info';
import { LogoImg } from '@domain/game.selection/game.list.item.styles';

interface GameListItemProps {
  game: GameInfo;
}

export const GameListItem = ({ game }: GameListItemProps) => {
  return (
    <Grid item>
      <Card>
        <CardContent>
          <Link to={`/${game.urlId}`}>
            <LogoImg src={game.logoImgSrc} alt={game.title} />
          </Link>
        </CardContent>
      </Card>
    </Grid>
  );
};
